const Test2 =()=>{
    return(
        <>
        <h1 className="mx-5 my-5">Navigated Succefully 👍</h1>
        </>
    )
}

export default Test2;